// import axios from 'axios'
// import refreshAttribute from '../utils/refreshAttribute'

export default {
  name: "card-profile",

  events: [
    {
      on: "click",
      handle(e) {
        const index = this.props.index;
        const modal = document.querySelector(`#profile-modal-${this.props.id}`);
        const swiper = modal.querySelector("[js-slider-el]").swiper;

        if (swiper) {
          swiper.slideTo(index, 0);
        }

        // const modalPipe = getPipe(modal.getAttribute("data-pipe-id"));
        // if (modalPipe) {
        //   const swiper = modal.querySelector("[js-slider-el]").swiper;
        //   modalPipe.on(({ action, emitterEl }) => {
        //     switch (action) {
        //       case MODAL_ACTIONS.OPEN: {
        //         swiper.slideTo(this.props.index, 0);
        //         break;
        //       }
        //     }
        //   });
        // }
      },
    },
  ],

  /*
  DANS LE CAS D'UN CHARGEMENT AJAX

  events: [
    {
      on: 'click',
      handle (e) {
        e.preventDefault()
        if (!this.el.getAttribute('js-modal-control')) {
          this.request()
        }
      },
    },
  ],

  componentDidMount () {
    this.modalID = this.id = this.props.id
    this.id = this.props.id
  },

  request () {
    axios
      .get(`/ajax/profile/${this.id}`)
      .then((response) => {
        // console.log(response.data)
        this.createModal(response.data)
      })
      .catch(function (error) {
        // handle error
        console.log(error)
      })
  },

  createModal (data) {
    const node = document.createElement('div')
    node.classList.add('modal', 'profile-modal', 'is-hidden', 'modal--aside')
    node.id = `profile-modal-${this.modalID}`
    node.setAttribute('js-modal', '')

    // node.appendChild(stringToHTML(data))
    node.innerHTML = data
    this.el.setAttribute(
      'js-modal-control',
      `{'target': '#profile-modal-${this.modalID}'}`,
    )
    node.setAttribute('js-modal-profile', '')
    document.querySelector('.modals').appendChild(node)
    // refreshAttribute('js-video-player')(node.querySelector('.video'))

    setTimeout(() => {
      this.el.click()
    }, 300)
  }, */
};
